import { ColumnDef } from '@tanstack/react-table';
import {
  DownloadedCheckmark,
  SortableHeader,
  TruncatedCell,
} from '@/components';
import { formatISODate } from '@/utils/date';
import { OriginalRecord } from '../types';
import { PatientDocumentViewButton } from '../../components';
import { DocumentSource, DocumentType } from '../../viewer';
import { EMPTY } from '../../templates/templateUtils';

export const createOriginalRecordsColumns = (): ColumnDef<OriginalRecord>[] => [
  {
    accessorKey: 'name',
    header: 'Document',
    cell: ({ row }) =>
      row.original.name ? <TruncatedCell text={row.original.name} /> : EMPTY,
  },
  {
    id: 'dateUploaded',
    accessorFn: (row) => row.dateUploaded,
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Date Uploaded</SortableHeader>
    ),
    cell: ({ row }) =>
      row.original.dateUploaded
        ? formatISODate(row.original.dateUploaded)
        : EMPTY,
  },
  {
    accessorKey: 'sourceType',
    enableSorting: true,
    header: ({ column }) => (
      <SortableHeader column={column}>Source Type</SortableHeader>
    ),
    cell: ({ row }) => row.original.sourceType || EMPTY,
  },
  {
    id: 'markedDownloaded', // currently not supported
    enableSorting: false,
    header: '',
    cell: ({ row }) =>
      row.original.markedDownloaded ? <DownloadedCheckmark /> : null,
  },
  {
    id: 'actions',
    enableSorting: false,
    header: '',
    cell: ({ row }) => (
      <div className="flex items-center justify-end gap-1">
        <PatientDocumentViewButton
          disabled={!row.original.sourceType}
          documentKey={{
            source: DocumentSource.MEDICAL_RECORDS,
            type: DocumentType.ORIGINAL_RECORDS,
            originalRecordId: row.original.id,
            sourceType: row.original.sourceType,
            name: row.original.name,
          }}
        />
      </div>
    ),
  },
];
